//Action for triggering login
export const login = () => ({
    type: 'LOGIN'
})

//Action for triggering logout
export const logout = () => ({
    type: 'LOGOUT'
})